import { set } from "animejs";

export const greenhouse = () => ({
    jobs: [],
    totalJobs: 0,
    erroring: false,
    levels: [],
    companies: [],
    departments: [],
    locations: [],
    loading: true,
    filters: {
        companies: null,
        levels: null,
        locations: null,
        departments: null,
        search: null
    },
    get currentJobs() {
        const alpine = this
        const filters = alpine.filters
        const hasAnyFilter = Object.values(filters).some(value => value !== null);

        if (hasAnyFilter) {

            let jobs = Array.from(alpine.jobs)
            
            for (const [key, value] of Object.entries(filters)) {
                
                if (value) {
                    if (key == 'search') {
                        jobs = jobs.filter((job) => hasSubstring(job, value))
                    } else {
                        jobs = jobs.filter((job) => {
                            return job[key] == value
                        })
                    } 
                }
            }

            return jobs
        }
        
        return alpine.jobs
    },
    parseJob() {

    },
    assignValues(values) {
        for (const [key, value] of Object.entries(values)) {
            this[key] = value
        }
    },
    async getJobs() {
        const greenhouseUrl = 'https://boards-api.greenhouse.io/v1/boards/flagshippioneeringinc/jobs?content=true'
        const alpine = this
        fetch(greenhouseUrl)
        .then(async (response) => {
            
            if (!response.ok) {
                throw new Error(`Response status: ${response.status}`);
            }

            const result = await response.json()
            const processedResult = parseGreenhouseResponse(result.jobs)
            this.assignValues(processedResult)
            this.loading = false
            this.totalJobs = result.meta.total
        })
        .catch((error) => {
            console.log(error.message)
        })

    },
    async init() {
        await this.getJobs()
    }

})

function hasSubstring(obj, substring) {
    const lowerSubstring = substring.toLowerCase();

    for (const [key, value] of Object.entries(obj)) {
        if (['title', 'locations', 'companies'].includes(key)) {
            let lowercaseVal = value.toLowerCase()
            console.log(key)
            if (lowercaseVal.includes(lowerSubstring)) {
                console.log(key + ': ' + lowercaseVal + ' = ' + lowerSubstring)
                return true
            }
        }
    }
  return false
}

function parseGreenhouseResponse(jobs) {

    if (!jobs) {
        this.erroring = true
        throw new Error('Greenhouse jobs are not defined')
    }

    const parsedJobs = []
    const companiesSet = new Set()
    const departmentsSet = new Set()
    const levelsSet = new Set()
    const locationsSet = new Set()

    const filters = [
        {
            alpineProp: 'companies',
            jobProp: 'offices',
            set: companiesSet
        },
        {
            alpineProp: 'departments',
            jobProp: 'departments',
            set: departmentsSet
        },
        {
            alpineProp: 'locations',
            jobProp: 'location',
            set: levelsSet
        },
        {
            name: 'level',
            alpineProp: 'levels',
            jobProp: 'metadata',
            set: locationsSet
        }
    ]

    let jobArr = Array.from(jobs)


    for (const job of jobArr) {

        const parsedJob = {title: job.title, url: job.absolute_url}

        for (const filter of filters) {
            let hasFilter = Object.hasOwn(job, filter.jobProp)

            const isLocationFilter = filter.alpineProp == 'locations'
            const isLevelFilter = filter.alpineProp == 'levels'


            if (isLocationFilter) {
                hasFilter = typeof job.location.name !== 'undefined'
            } else if (isLevelFilter) {
                const metadata = job.metadata.find(el => el.name == "Level")
                hasFilter = typeof metadata !== 'undefined'
            } else {
                hasFilter = job[filter.jobProp].length > 0
            }

            if (hasFilter) {
                const name = isLocationFilter ? formateLocation(job.location.name) :
                                isLevelFilter ? job.metadata.find(el => el.name == "Level").value :
                                job[filter.jobProp][0].name
                
                parsedJob[filter.alpineProp] = name
                filter.set.add(name)
                
            } else {
                console.error(job.title + " does not have " + filter.alpineProp)
            }
        }

        parsedJobs.push(parsedJob)
    }

    let finalGreenhouseResult = {
        jobs: parsedJobs
    }

    for (const filter of filters) {
        finalGreenhouseResult[filter.alpineProp] = Array.from(filter.set).sort()
    }

    return finalGreenhouseResult

}

function formateLocation(location) {
    if (location.toLowerCase() == 'remote') {
        return location
    } else {
        return location.replace("USA", "")
    }
}